<span [matMenuTriggerFor]="menu" aria-label="Document picker menu" *ngIf="!loading">
  <ng-content *ngIf="!document" select="[app-document-picker-control-empty]"></ng-content>
  <ng-content *ngIf="document" select="[app-document-picker-control-selected]"></ng-content>
</span>

<span>
  <ng-content *ngIf="loading" select="[app-document-picker-control-loading]"></ng-content>
</span>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    (click)="fileInput.click()">
    Computer
  </button>
  <button mat-menu-item [matMenuTriggerFor]="documentsTab" [disabled]="!(documents$ | async)?.length">
    Documents Tab
  </button>
</mat-menu>

<mat-menu #documentsTab="matMenu">
  <!-- TODO add tooltip delay -->
  <button mat-menu-item *ngFor="let document of (documents$ | async)" (click)="handleSelect(document)" [matTooltip]="document.title">
    {{ document.title }}
  </button>
</mat-menu>

<input
  #fileInput
  type="file"
  (change)="handleUpload($event.target.files[0]); $event.target.value = ''"
  style="display:none;"
  [accept]="typesAccepted"
/>
